export const REQUIRED_DOCUMENTS = [
  { key: "government_id", label: "Government ID" },
  { key: "professional_license", label: "Professional License / Certification" },
  { key: "tb_test", label: "TB Test / Health Clearance" },
  { key: "cpr_bls", label: "CPR / BLS Certification" },
];

export const PIPELINE_STAGES = {
  APPLICANT: "applicant",
  INVITED: "invited",
  REGISTERED: "registered",
  ONBOARDING: "onboarding",
  MISSING_DOCS: "missing_docs",
  IN_PROGRESS: "in_progress",
  SUBMITTED: "submitted",
  PENDING_REVIEW: "pending_review",
  REVIEW_QUEUE: "review_queue",
  APPROVED: "approved",
  READY: "ready",
  REJECTED: "rejected",
  REUPLOAD_REQUIRED: "reupload_required",
};

export const PIPELINE_STATUSES = {
  INVITED: "INVITED",
  SIGNED_UP: "SIGNED UP",
  MISSING_DOCUMENTS: "MISSING DOCUMENTS",
  PENDING_REVIEW: "PENDING REVIEW",
  READY_FOR_SHIFTS: "READY FOR SHIFTS",
  ACTION_REQUIRED: "ACTION REQUIRED",
  REJECTED: "REJECTED",
};

export const PIPELINE_ORDER = {
  "PENDING REVIEW": 1,
  "ACTION REQUIRED": 2,
  "MISSING DOCUMENTS": 3,
  "SIGNED UP": 4,
  INVITED: 5,
  REJECTED: 6,
  "READY FOR SHIFTS": 99,
};

export function getRequiredDocumentKey(docItem) {
  return docItem?.key || docItem?.[0] || "";
}